import { render, staticRenderFns } from "./reatimevid.vue?vue&type=template&id=790fe48e&scoped=true"
import script from "./reatimevid.vue?vue&type=script&lang=js"
export * from "./reatimevid.vue?vue&type=script&lang=js"
import style0 from "./reatimevid.vue?vue&type=style&index=0&id=790fe48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790fe48e",
  null
  
)

export default component.exports